type Slot = {
  attendanceImpacts: Array<{
    hasConflict: boolean;
    inconveniences: string[];
  }>;
};
export const countImpacts = (slot: Slot) => {
  const impactTypes = new Set();
  let count = slot.attendanceImpacts?.filter((impact) => impact.hasConflict).length;

  if (count > 0) {
    impactTypes.add("Conflict");
  }

  count += slot.attendanceImpacts?.reduce((accum, impact) => {
    impact?.inconveniences?.forEach((incon: string) => impactTypes.add(incon));
    return accum + impact?.inconveniences?.length || 0;
  }, 0);

  return [count, impactTypes.size];
};
